<div style="display: grid; grid-template-columns: repeat(3, 1fr); gap: 20px;" id="union-grid" class="p-30">
  <div class="flex align-items-center content-between mb-10" style="grid-column: 1 / -1;">
    <div class="flex align-items-center gap-10">
      <img src="assets/profile-blue-icon.svg" alt="">
      <h3 class="dark-blue no-margin">Organisation syndicale {{index + 1}}</h3>
    </div>
  </div>
  <div style="grid-column: 1 / -1;">
    <p class="dark-gray no-margin">Nom de l'organisation</p>
    <p class="dark-blue bold">{{union.unionName}}</p>
  </div>

  <div>
    <p class="dark-gray no-margin">Civilité</p>
    <p class="dark-blue bold">{{union.man ? 'Monsieur' : 'Madame'}}</p>
  </div>

  <div>
    <p class="dark-gray no-margin">Prénom du représentant</p>
    <p class="dark-blue bold">{{union.firstName}}</p>
  </div>

  <div>
    <p class="dark-gray no-margin">Nom du représentant</p>
    <p class="dark-blue bold">{{union.lastName}}</p>
  </div>

</div>